import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ChevronLeftIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M8.49976 17.5239V14.4761L26.4998 1V7.12549L14.5067 16L26.4998 24.8745V31L8.49976 17.5239Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
